import { z } from "zod";


const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalDate = z.coerce.date().nullable().optional(); 
const optionalBoolean = z.boolean().nullable().optional();

export const DiarioObrasSchema = z.object({
    IdDiarioObras: z.number().int().default(0), 
    IdCentroCusto: optionalNumber,
    IdCliente: optionalNumber,
    IdClienteCentroCusto: optionalNumber,
    IdFuncionarioResponsavel: optionalNumber,
    IdFuncionarioAprovador: optionalNumber,
    NumeroDocumento: optionalString,
    DataCadastro: optionalDate,
    ResponsavelPor: optionalString,
    AprovadoPor: optionalString,
    CondicaoTempo: optionalString,
    DiaPraticavel: optionalString, 
    Observacao: optionalString,
    Status: optionalNumber,
    StatusNome: optionalString,
    Delete: optionalBoolean,
    JustificativaDia: optionalString,
    AssinaturaCliente: z.string().nullable().optional(),
    AssinaturaConstrutora: z.string().nullable().optional(),
    NroDiario: optionalNumber,
    DataAlteracao: optionalDate,
    HorarioTrabalhoDe: optionalString,
    HorarioTrabalhoAte: optionalString,
    HorarioAlmocoDe: optionalString,
    HorarioAlmocoAte: optionalString,

    //Extra front
    ResponsavelCadastrado: optionalBoolean,
    AprovadoPorCadastrado: optionalBoolean,
});

export type DiarioObrasForm = z.infer<typeof DiarioObrasSchema>;